import { z } from 'zod';
export const SearchRecipeRequestSchema = z.object({
    name: z.string().describe('Nombre de la receta a buscar'),
    recipeId: z
        .string()
        .optional()
        .describe('ID de la receta a buscar. Usa este campo cuando tengas el ID de la receta disponible.'),
});
//# sourceMappingURL=SearchRecipeRequestSchema.js.map